"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BOVehicleDetailsFormProvider = void 0;
var react_1 = __importDefault(require("react"));
var BOVehicleDetailsFormContext_1 = require("./BOVehicleDetailsFormContext");
var BOVehicleDetailsFormProvider = function (props) {
    var children = props.children, countryCode = props.countryCode, fetchYears = props.fetchYears, fetchAssetTypes = props.fetchAssetTypes, fetchMakes = props.fetchMakes, fetchModels = props.fetchModels, fetchOptions = props.fetchOptions, fetchStates = props.fetchStates;
    var formContextValue = BOVehicleDetailsFormContext_1.useBOVehicleDetailsFormContextValue({
        countryCode: countryCode,
        fetchYears: fetchYears,
        fetchAssetTypes: fetchAssetTypes,
        fetchMakes: fetchMakes,
        fetchModels: fetchModels,
        fetchOptions: fetchOptions,
        fetchStates: fetchStates,
    });
    return (react_1.default.createElement(BOVehicleDetailsFormContext_1.BOVehicleDetailsFormContext.Provider, { value: formContextValue }, children));
};
exports.BOVehicleDetailsFormProvider = BOVehicleDetailsFormProvider;
//# sourceMappingURL=BOVehicleDetailsFormProvider.js.map